export default __webpack_public_path__ + "static/media/nl-consultoria.4a30273b.webp";